import { render, staticRenderFns } from "./InnovationUpload.vue?vue&type=template&id=4d6e255c&scoped=true&"
import script from "./InnovationUpload.vue?vue&type=script&lang=js&"
export * from "./InnovationUpload.vue?vue&type=script&lang=js&"
import style0 from "./InnovationUpload.vue?vue&type=style&index=0&id=4d6e255c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6e255c",
  null
  
)

export default component.exports